export * from '@primeuix/themes/nora/inputtext';
export { default } from '@primeuix/themes/nora/inputtext';
